// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import PlateSearchController from "./plate_search_controller"
application.register("plate-search", PlateSearchController)
